import { Order, Sort } from 'reactApp/types/QuotaCleaner';

export const getSortParams = (isYearAllView: boolean): { sort: Sort; order: Order } => {
    return {
        sort: isYearAllView ? Sort.mtime : Sort.size,
        order: isYearAllView ? Order.asc : Order.desc,
    };
};
